let $ = require('jquery');

function stickyHeader() {
  let $stickyHeader = $('.sticky-header');
  let previousScroll = 0;
  let isFirstHidden = true;

  $(window).on('scroll.has-sticky-header', function () {
    let height = $('.sticky-header').outerHeight(true);
    let currentScroll = $(window).scrollTop();

    if (currentScroll >= height) {
      $('body').addClass('has-sticky-header');
      if (currentScroll < previousScroll) {
        // scroll-up
        $stickyHeader.removeClass('sticky-header--hidden sticky-header--hidden-first');
      } else {
        // scroll-down
        if (isFirstHidden) {
          $stickyHeader.addClass('sticky-header--hidden-first');
          isFirstHidden = false;
        } else {
          $stickyHeader.addClass('sticky-header--hidden');
        }
      }
    } else {
      if ($(window).width() <= 1024) {
        if (0 == currentScroll) {
          $stickyHeader.removeClass('sticky-header--hidden sticky-header--hidden-first');
          $('body').removeClass('has-sticky-header');
          isFirstHidden = true;
        }
      } else {
        $stickyHeader.removeClass('sticky-header--hidden sticky-header--hidden-first');
        $('body').removeClass('has-sticky-header');
        isFirstHidden = true;
      }
    }

    previousScroll = currentScroll;
  });
}

export default stickyHeader;
